class modalUnindentificationCtrl {
    constructor($scope, $uibModalInstance, items3, httpRequest, globalFn) {
        $scope.noAuthCheckDetailList={}
        function fixNumber(v){
            if(v===null||v===''||v===undefined)return ''
            return v.toFixed(2)
        }
        httpRequest.post_noCheckData( {
            'creditCodeList':[items3.creditCode],
            periodCode: items3.periodCode,
        }).then((res) => {
            if (res.data.success) {
                let result=res.data.value
                result.totalInvoiceAmount=fixNumber(result.totalInvoiceAmount)
                result.totalInvoiceTax=fixNumber(result.totalInvoiceTax)
                result.noAuthCheckDetailList.forEach(item=>{
                    item.invoiceAmount=fixNumber(item.invoiceAmount)
                    item.invoiceTax=fixNumber(item.invoiceTax)
                })
               $scope.noAuthCheckDetailList=result

            }
        })
        $scope.cancel = () => {
            $uibModalInstance.close()
        }
        $scope.exportUnindent = () => {
            const req = {
                'creditCodeList':[items3.creditCode],
                periodCode: items3.periodCode,
                accessToken: localStorage.id_token,
            }
            httpRequest.get_exportExportNoCheckData(req)
        }
    }
}

modalUnindentificationCtrl.$inject = ['$scope', '$uibModalInstance', 'items3', 'httpRequest', 'globalFn']
export default modalUnindentificationCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/inputStatistics/identificationSummarize/modalUnindentificationCtrl.js